import { Component } from '@angular/core';
import { Router ,ActivatedRoute, NavigationEnd} from '@angular/router';
import { TripService } from 'src/app/services/trip.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';

@Component({
  selector: 'app-approval-trip',
  templateUrl: './approval-trip.component.html',
  styleUrls: ['./approval-trip.component.css']
})
export class ApprovalTripComponent {
  successPopup:boolean=false
  updatefunction:boolean=false

  comment: string = '';
  tripUid:any
  currentRoute:any;
constructor(private toastMsgService:ToastmsgService,private TripService:TripService,private router:Router,private route: ActivatedRoute){
   

  this.currentRoute = this.router?.routerState?.snapshot?.url.split('/')[1];
this.route.paramMap.subscribe(params => {
 let id= params.get('token');
 if(id){
  this.tripUid=id
//  this.paymentOrderData(id)
 }
});
}
action:any
  onApprove() {
    // this.successPopup=true
this.action='A'
    this.createTrip('A')
    // alert(`Approved with comment: ${this.comment}`);
    // Add logic for approve action
  }
//   APPROVED.   ====>. A
// DECLINED.   ======> D
  createTrip(status:any) {

    let request:any={
      "approvalNotes":this.comment,
      "tripUid":this.tripUid,
      "status":status,
    }
    
     this.TripService
     .approveTripRequest(request)
     .subscribe({
       next : (res:any) => {
        this.successPopup=true
      this.toastMsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
         if(res) {
        let data=res
        
         } else {
         
         } 
       },error : (err) => {
 
         this.toastMsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});
   
       }
     }
   )
   
     // Logic for trip creation goes here.
   }
  onReject() {
    this.action='D'
    // this.successPopup=true

    this.createTrip('D')

    // alert(`Rejected with comment: ${this.comment}`);
    // Add logic for reject action
  }


  
}
